export const EMOJIS = [
  {
    "emojis": [
      [
        "ï¿½ï¿½",
        "smile"
      ],
      [
        "ï¿½ï¿½",
        "smiley"
      ],
      [
        "ï¿½ï¿½",
        "grinning"
      ],
      [
        "ï¿½ï¿½",
        "blush"
      ],
      [
        "âº",
        "relaxed"
      ],
      [
        "ï¿½ï¿½",
        "wink"
      ],
      [
        "ï¿½ï¿½",
        "heart_eyes"
      ],
      [
        "ï¿½ï¿½",
        "kissing_heart"
      ],
      [
        "ï¿½ï¿½",
        "kissing_closed_eyes"
      ],
      [
        "ï¿½ï¿½",
        "kissing"
      ],
      [
        "ï¿½ï¿½",
        "kissing_smiling_eyes"
      ],
      [
        "ï¿½ï¿½",
        "stuck_out_tongue_winking_eye"
      ],
      [
        "ï¿½ï¿½",
        "stuck_out_tongue_closed_eyes"
      ],
      [
        "ï¿½ï¿½",
        "stuck_out_tongue"
      ],
      [
        "ï¿½ï¿½",
        "flushed"
      ],
      [
        "ï¿½ï¿½",
        "grin"
      ],
      [
        "ï¿½ï¿½",
        "pensive"
      ],
      [
        "ï¿½ï¿½",
        "relieved"
      ],
      [
        "ï¿½ï¿½",
        "unamused"
      ],
      [
        "ï¿½ï¿½",
        "disappointed"
      ],
      [
        "ï¿½ï¿½",
        "persevere"
      ],
      [
        "ï¿½ï¿½",
        "cry"
      ],
      [
        "ï¿½ï¿½",
        "joy"
      ],
      [
        "ï¿½ï¿½",
        "sob"
      ],
      [
        "ï¿½ï¿½",
        "sleepy"
      ],
      [
        "ï¿½ï¿½",
        "disappointed_relieved"
      ],
      [
        "ï¿½ï¿½",
        "cold_sweat"
      ],
      [
        "ï¿½ï¿½",
        "sweat_smile"
      ],
      [
        "ï¿½ï¿½",
        "sweat"
      ],
      [
        "ï¿½ï¿½",
        "weary"
      ],
      [
        "ï¿½ï¿½",
        "tired_face"
      ],
      [
        "ï¿½ï¿½",
        "fearful"
      ],
      [
        "ï¿½ï¿½",
        "scream"
      ],
      [
        "ï¿½ï¿½",
        "angry"
      ],
      [
        "ï¿½ï¿½",
        "rage"
      ],
      [
        "ï¿½ï¿½",
        "triumph"
      ],
      [
        "ï¿½ï¿½",
        "confounded"
      ],
      [
        "ï¿½ï¿½",
        "laughing"
      ],
      [
        "ï¿½ï¿½",
        "yum"
      ],
      [
        "ï¿½ï¿½",
        "mask"
      ],
      [
        "ï¿½ï¿½",
        "sunglasses"
      ],
      [
        "ï¿½ï¿½",
        "sleeping"
      ],
      [
        "ï¿½ï¿½",
        "dizzy_face"
      ],
      [
        "ï¿½ï¿½",
        "astonished"
      ],
      [
        "ï¿½ï¿½",
        "worried"
      ],
      [
        "ï¿½ï¿½",
        "frowning"
      ],
      [
        "ï¿½ï¿½",
        "anguished"
      ],
      [
        "ï¿½ï¿½",
        "imp"
      ],
      [
        "ï¿½ï¿½",
        "open_mouth"
      ],
      [
        "ï¿½ï¿½",
        "grimacing"
      ],
      [
        "ï¿½ï¿½",
        "neutral_face"
      ],
      [
        "ï¿½ï¿½",
        "confused"
      ],
      [
        "ï¿½ï¿½",
        "hushed"
      ],
      [
        "ï¿½ï¿½",
        "smirk"
      ],
      [
        "ï¿½ï¿½",
        "expressionless"
      ],
      [
        "ï¿½ï¿½",
        "man_with_gua_pi_mao"
      ],
      [
        "ï¿½ï¿½",
        "man_with_turban"
      ],
      [
        "ï¿½ï¿½",
        "cop"
      ],
      [
        "ï¿½ï¿½",
        "construction_worker"
      ],
      [
        "ï¿½ï¿½",
        "guardsman"
      ],
      [
        "ï¿½ï¿½",
        "baby"
      ],
      [
        "ï¿½ï¿½",
        "boy"
      ],
      [
        "ï¿½ï¿½",
        "girl"
      ],
      [
        "ï¿½ï¿½",
        "man"
      ],
      [
        "ï¿½ï¿½",
        "woman"
      ],
      [
        "ï¿½ï¿½",
        "older_man"
      ],
      [
        "ï¿½ï¿½",
        "older_woman"
      ],
      [
        "ï¿½ï¿½",
        "person_with_blond_hair"
      ],
      [
        "ï¿½ï¿½",
        "angel"
      ],
      [
        "ï¿½ï¿½",
        "princess"
      ],
      [
        "ï¿½ï¿½",
        "smiley_cat"
      ],
      [
        "ï¿½ï¿½",
        "smile_cat"
      ],
      [
        "ï¿½ï¿½",
        "heart_eyes_cat"
      ],
      [
        "ï¿½ï¿½",
        "kissing_cat"
      ],
      [
        "ï¿½ï¿½",
        "smirk_cat"
      ],
      [
        "ï¿½ï¿½",
        "scream_cat"
      ],
      [
        "ï¿½ï¿½",
        "crying_cat_face"
      ],
      [
        "ï¿½ï¿½",
        "joy_cat"
      ],
      [
        "ï¿½ï¿½",
        "pouting_cat"
      ],
      [
        "ï¿½ï¿½",
        "japanese_ogre"
      ],
      [
        "ï¿½ï¿½",
        "japanese_goblin"
      ],
      [
        "ï¿½ï¿½",
        "see_no_evil"
      ],
      [
        "ï¿½ï¿½",
        "hear_no_evil"
      ],
      [
        "ï¿½ï¿½",
        "speak_no_evil"
      ],
      [
        "ï¿½ï¿½",
        "skull"
      ],
      [
        "ï¿½ï¿½",
        "alien"
      ],
      [
        "ï¿½ï¿½",
        "hankey"
      ],
      [
        "ï¿½ï¿½",
        "fire"
      ],
      [
        "â¨",
        "sparkles"
      ],
      [
        "ï¿½ï¿½",
        "star2"
      ],
      [
        "ï¿½ï¿½",
        "dizzy"
      ],
      [
        "ï¿½ï¿½",
        "boom"
      ],
      [
        "ï¿½ï¿½",
        "anger"
      ],
      [
        "ï¿½ï¿½",
        "sweat_drops"
      ],
      [
        "ï¿½ï¿½",
        "droplet"
      ],
      [
        "ï¿½ï¿½",
        "zzz"
      ],
      [
        "ï¿½ï¿½",
        "dash"
      ],
      [
        "ï¿½ï¿½",
        "ear"
      ],
      [
        "ï¿½ï¿½",
        "eyes"
      ],
      [
        "ï¿½ï¿½",
        "nose"
      ],
      [
        "ï¿½ï¿½",
        "tongue"
      ],
      [
        "ï¿½ï¿½",
        "lips"
      ],
      [
        "ï¿½ï¿½",
        "+1"
      ],
      [
        "ï¿½ï¿½",
        "-1"
      ],
      [
        "ï¿½ï¿½",
        "ok_hand"
      ],
      [
        "ï¿½ï¿½",
        "facepunch"
      ],
      [
        "â",
        "fist"
      ],
      [
        "â",
        "v"
      ],
      [
        "ï¿½ï¿½",
        "wave"
      ],
      [
        "â",
        "hand"
      ],
      [
        "ï¿½ï¿½",
        "open_hands"
      ],
      [
        "ï¿½ï¿½",
        "point_up_2"
      ],
      [
        "ï¿½ï¿½",
        "point_down"
      ],
      [
        "ï¿½ï¿½",
        "point_right"
      ],
      [
        "ï¿½ï¿½",
        "point_left"
      ],
      [
        "ï¿½ï¿½",
        "raised_hands"
      ],
      [
        "ï¿½ï¿½",
        "pray"
      ],
      [
        "â",
        "point_up"
      ],
      [
        "ï¿½ï¿½",
        "clap"
      ],
      [
        "ï¿½ï¿½",
        "muscle"
      ],
      [
        "ï¿½ï¿½",
        "walking"
      ],
      [
        "ï¿½ï¿½",
        "runner"
      ],
      [
        "ï¿½ï¿½",
        "dancer"
      ],
      [
        "ï¿½ï¿½",
        "couple"
      ],
      [
        "ï¿½ï¿½",
        "family"
      ],
      [
        "ï¿½ï¿½",
        "couplekiss"
      ],
      [
        "ï¿½ï¿½",
        "couple_with_heart"
      ],
      [
        "ï¿½ï¿½",
        "dancers"
      ],
      [
        "ï¿½ï¿½",
        "ok_woman"
      ],
      [
        "ï¿½ï¿½",
        "no_good"
      ],
      [
        "ï¿½ï¿½",
        "information_desk_person"
      ],
      [
        "ï¿½ï¿½",
        "raising_hand"
      ],
      [
        "ï¿½ï¿½",
        "massage"
      ],
      [
        "ï¿½ï¿½",
        "haircut"
      ],
      [
        "ï¿½ï¿½",
        "nail_care"
      ],
      [
        "ï¿½ï¿½",
        "bride_with_veil"
      ],
      [
        "ï¿½ï¿½",
        "person_with_pouting_face"
      ],
      [
        "ï¿½ï¿½",
        "person_frowning"
      ],
      [
        "ï¿½ï¿½",
        "bow"
      ],
      [
        "ï¿½ï¿½",
        "tophat"
      ],
      [
        "ï¿½ï¿½",
        "crown"
      ],
      [
        "ï¿½ï¿½",
        "womans_hat"
      ],
      [
        "ï¿½ï¿½",
        "athletic_shoe"
      ],
      [
        "ï¿½ï¿½",
        "mans_shoe"
      ],
      [
        "ï¿½ï¿½",
        "sandal"
      ],
      [
        "ï¿½ï¿½",
        "high_heel"
      ],
      [
        "ï¿½ï¿½",
        "boot"
      ],
      [
        "ï¿½ï¿½",
        "shirt"
      ],
      [
        "ï¿½ï¿½",
        "necktie"
      ],
      [
        "ï¿½ï¿½",
        "womans_clothes"
      ],
      [
        "ï¿½ï¿½",
        "dress"
      ],
      [
        "ï¿½ï¿½",
        "running_shirt_with_sash"
      ],
      [
        "ï¿½ï¿½",
        "jeans"
      ],
      [
        "ï¿½ï¿½",
        "kimono"
      ],
      [
        "ï¿½ï¿½",
        "bikini"
      ],
      [
        "ï¿½ï¿½",
        "briefcase"
      ],
      [
        "ï¿½ï¿½",
        "handbag"
      ],
      [
        "ï¿½ï¿½",
        "pouch"
      ],
      [
        "ï¿½ï¿½",
        "purse"
      ],
      [
        "ï¿½ï¿½",
        "eyeglasses"
      ],
      [
        "ï¿½ï¿½",
        "ribbon"
      ],
      [
        "ï¿½ï¿½",
        "closed_umbrella"
      ],
      [
        "ï¿½ï¿½",
        "lipstick"
      ],
      [
        "ï¿½ï¿½",
        "yellow_heart"
      ],
      [
        "ï¿½ï¿½",
        "blue_heart"
      ],
      [
        "ï¿½ï¿½",
        "purple_heart"
      ],
      [
        "ï¿½ï¿½",
        "green_heart"
      ],
      [
        "â¤",
        "heart"
      ],
      [
        "ï¿½ï¿½",
        "broken_heart"
      ],
      [
        "ï¿½ï¿½",
        "heartpulse"
      ],
      [
        "ï¿½ï¿½",
        "heartbeat"
      ],
      [
        "ï¿½ï¿½",
        "two_hearts"
      ],
      [
        "ï¿½ï¿½",
        "sparkling_heart"
      ],
      [
        "ï¿½ï¿½",
        "revolving_hearts"
      ],
      [
        "ï¿½ï¿½",
        "cupid"
      ],
      [
        "ï¿½ï¿½",
        "love_letter"
      ],
      [
        "ï¿½ï¿½",
        "kiss"
      ],
      [
        "ï¿½ï¿½",
        "ring"
      ],
      [
        "ï¿½ï¿½",
        "gem"
      ],
      [
        "ï¿½ï¿½",
        "bust_in_silhouette"
      ],
      [
        "ï¿½ï¿½",
        "speech_balloon"
      ],
      [
        "ï¿½ï¿½",
        "footprints"
      ]
    ],
    "name": "People",
    "icon": ["ï¿½ï¿½", "smile"]
  },
  {
    "emojis": [
      [
        "ï¿½ï¿½",
        "dog"
      ],
      [
        "ï¿½ï¿½",
        "wolf"
      ],
      [
        "ï¿½ï¿½",
        "cat"
      ],
      [
        "ï¿½ï¿½",
        "mouse"
      ],
      [
        "ï¿½ï¿½",
        "hamster"
      ],
      [
        "ï¿½ï¿½",
        "rabbit"
      ],
      [
        "ï¿½ï¿½",
        "frog"
      ],
      [
        "ï¿½ï¿½",
        "tiger"
      ],
      [
        "ï¿½ï¿½",
        "koala"
      ],
      [
        "ï¿½ï¿½",
        "bear"
      ],
      [
        "ï¿½ï¿½",
        "pig"
      ],
      [
        "ï¿½ï¿½",
        "pig_nose"
      ],
      [
        "ï¿½ï¿½",
        "cow"
      ],
      [
        "ï¿½ï¿½",
        "boar"
      ],
      [
        "ï¿½ï¿½",
        "monkey_face"
      ],
      [
        "ï¿½ï¿½",
        "monkey"
      ],
      [
        "ï¿½ï¿½",
        "horse"
      ],
      [
        "ï¿½ï¿½",
        "sheep"
      ],
      [
        "ï¿½ï¿½",
        "elephant"
      ],
      [
        "ï¿½ï¿½",
        "panda_face"
      ],
      [
        "ï¿½ï¿½",
        "penguin"
      ],
      [
        "ï¿½ï¿½",
        "bird"
      ],
      [
        "ï¿½ï¿½",
        "baby_chick"
      ],
      [
        "ï¿½ï¿½",
        "hatched_chick"
      ],
      [
        "ï¿½ï¿½",
        "hatching_chick"
      ],
      [
        "ï¿½ï¿½",
        "chicken"
      ],
      [
        "ï¿½ï¿½",
        "snake"
      ],
      [
        "ï¿½ï¿½",
        "turtle"
      ],
      [
        "ï¿½ï¿½",
        "bug"
      ],
      [
        "ï¿½ï¿½",
        "bee"
      ],
      [
        "ï¿½ï¿½",
        "ant"
      ],
      [
        "ï¿½ï¿½",
        "beetle"
      ],
      [
        "ï¿½ï¿½",
        "snail"
      ],
      [
        "ï¿½ï¿½",
        "octopus"
      ],
      [
        "ï¿½ï¿½",
        "shell"
      ],
      [
        "ï¿½ï¿½",
        "tropical_fish"
      ],
      [
        "ï¿½ï¿½",
        "fish"
      ],
      [
        "ï¿½ï¿½",
        "dolphin"
      ],
      [
        "ï¿½ï¿½",
        "whale"
      ],
      [
        "ï¿½ï¿½",
        "racehorse"
      ],
      [
        "ï¿½ï¿½",
        "dragon_face"
      ],
      [
        "ï¿½ï¿½",
        "blowfish"
      ],
      [
        "ï¿½ï¿½",
        "camel"
      ],
      [
        "ï¿½ï¿½",
        "poodle"
      ],
      [
        "ï¿½ï¿½",
        "feet"
      ],
      [
        "ï¿½ï¿½",
        "bouquet"
      ],
      [
        "ï¿½ï¿½",
        "cherry_blossom"
      ],
      [
        "ï¿½ï¿½",
        "tulip"
      ],
      [
        "ï¿½ï¿½",
        "four_leaf_clover"
      ],
      [
        "ï¿½ï¿½",
        "rose"
      ],
      [
        "ï¿½ï¿½",
        "sunflower"
      ],
      [
        "ï¿½ï¿½",
        "hibiscus"
      ],
      [
        "ï¿½ï¿½",
        "maple_leaf"
      ],
      [
        "ï¿½ï¿½",
        "leaves"
      ],
      [
        "ï¿½ï¿½",
        "fallen_leaf"
      ],
      [
        "ï¿½ï¿½",
        "herb"
      ],
      [
        "ï¿½ï¿½",
        "ear_of_rice"
      ],
      [
        "ï¿½ï¿½",
        "mushroom"
      ],
      [
        "ï¿½ï¿½",
        "cactus"
      ],
      [
        "ï¿½ï¿½",
        "palm_tree"
      ],
      [
        "ï¿½ï¿½",
        "chestnut"
      ],
      [
        "ï¿½ï¿½",
        "seedling"
      ],
      [
        "ï¿½ï¿½",
        "blossom"
      ],
      [
        "ï¿½ï¿½",
        "new_moon"
      ],
      [
        "ï¿½ï¿½",
        "first_quarter_moon"
      ],
      [
        "ï¿½ï¿½",
        "moon"
      ],
      [
        "ï¿½ï¿½",
        "full_moon"
      ],
      [
        "ï¿½ï¿½",
        "first_quarter_moon_with_face"
      ],
      [
        "ï¿½ï¿½",
        "crescent_moon"
      ],
      [
        "ï¿½ï¿½",
        "earth_asia"
      ],
      [
        "ï¿½ï¿½",
        "volcano"
      ],
      [
        "ï¿½ï¿½",
        "milky_way"
      ],
      [
        "ï¿½ï¿½",
        "stars"
      ],
      [
        "â­",
        "star"
      ],
      [
        "â",
        "sunny"
      ],
      [
        "â",
        "partly_sunny"
      ],
      [
        "â",
        "cloud"
      ],
      [
        "â¡",
        "zap"
      ],
      [
        "â",
        "umbrella"
      ],
      [
        "â",
        "snowflake"
      ],
      [
        "â",
        "snowman"
      ],
      [
        "ï¿½ï¿½",
        "cyclone"
      ],
      [
        "ï¿½ï¿½",
        "foggy"
      ],
      [
        "ï¿½ï¿½",
        "rainbow"
      ],
      [
        "ï¿½ï¿½",
        "ocean"
      ]
    ],
    "name": "Nature",
    "icon": ["ï¿½ï¿½", "cherry_blossom"]
  },
  {
    "emojis": [
      [
        "ï¿½ï¿½",
        "bamboo"
      ],
      [
        "ï¿½ï¿½",
        "gift_heart"
      ],
      [
        "ï¿½ï¿½",
        "dolls"
      ],
      [
        "ï¿½ï¿½",
        "school_satchel"
      ],
      [
        "ï¿½ï¿½",
        "mortar_board"
      ],
      [
        "ï¿½ï¿½",
        "flags"
      ],
      [
        "ï¿½ï¿½",
        "fireworks"
      ],
      [
        "ï¿½ï¿½",
        "sparkler"
      ],
      [
        "ï¿½ï¿½",
        "wind_chime"
      ],
      [
        "ï¿½ï¿½",
        "rice_scene"
      ],
      [
        "ï¿½ï¿½",
        "jack_o_lantern"
      ],
      [
        "ï¿½ï¿½",
        "ghost"
      ],
      [
        "ï¿½ï¿½",
        "santa"
      ],
      [
        "ï¿½ï¿½",
        "christmas_tree"
      ],
      [
        "ï¿½ï¿½",
        "gift"
      ],
      [
        "ï¿½ï¿½",
        "tanabata_tree"
      ],
      [
        "ï¿½ï¿½",
        "tada"
      ],
      [
        "ï¿½ï¿½",
        "confetti_ball"
      ],
      [
        "ï¿½ï¿½",
        "balloon"
      ],
      [
        "ï¿½ï¿½",
        "crossed_flags"
      ],
      [
        "ï¿½ï¿½",
        "crystal_ball"
      ],
      [
        "ï¿½ï¿½",
        "movie_camera"
      ],
      [
        "ï¿½ï¿½",
        "camera"
      ],
      [
        "ï¿½ï¿½",
        "video_camera"
      ],
      [
        "ï¿½ï¿½",
        "vhs"
      ],
      [
        "ï¿½ï¿½",
        "cd"
      ],
      [
        "ï¿½ï¿½",
        "dvd"
      ],
      [
        "ï¿½ï¿½",
        "minidisc"
      ],
      [
        "ï¿½ï¿½",
        "floppy_disk"
      ],
      [
        "ï¿½ï¿½",
        "computer"
      ],
      [
        "ï¿½ï¿½",
        "iphone"
      ],
      [
        "â",
        "phone"
      ],
      [
        "ï¿½ï¿½",
        "telephone_receiver"
      ],
      [
        "ï¿½ï¿½",
        "pager"
      ],
      [
        "ï¿½ï¿½",
        "fax"
      ],
      [
        "ï¿½ï¿½",
        "satellite"
      ],
      [
        "ï¿½ï¿½",
        "tv"
      ],
      [
        "ï¿½ï¿½",
        "radio"
      ],
      [
        "ï¿½ï¿½",
        "loud_sound"
      ],
      [
        "ï¿½ï¿½",
        "bell"
      ],
      [
        "ï¿½ï¿½",
        "loudspeaker"
      ],
      [
        "ï¿½ï¿½",
        "mega"
      ],
      [
        "â³",
        "hourglass_flowing_sand"
      ],
      [
        "â",
        "hourglass"
      ],
      [
        "â°",
        "alarm_clock"
      ],
      [
        "â",
        "watch"
      ],
      [
        "ï¿½ï¿½",
        "unlock"
      ],
      [
        "ï¿½ï¿½",
        "lock"
      ],
      [
        "ï¿½ï¿½",
        "lock_with_ink_pen"
      ],
      [
        "ï¿½ï¿½",
        "closed_lock_with_key"
      ],
      [
        "ï¿½ï¿½",
        "key"
      ],
      [
        "ï¿½ï¿½",
        "mag_right"
      ],
      [
        "ï¿½ï¿½",
        "bulb"
      ],
      [
        "ï¿½ï¿½",
        "flashlight"
      ],
      [
        "ï¿½ï¿½",
        "electric_plug"
      ],
      [
        "ï¿½ï¿½",
        "battery"
      ],
      [
        "ï¿½ï¿½",
        "mag"
      ],
      [
        "ï¿½ï¿½",
        "bath"
      ],
      [
        "ï¿½ï¿½",
        "toilet"
      ],
      [
        "ï¿½ï¿½",
        "wrench"
      ],
      [
        "ï¿½ï¿½",
        "nut_and_bolt"
      ],
      [
        "ï¿½ï¿½",
        "hammer"
      ],
      [
        "ï¿½ï¿½",
        "door"
      ],
      [
        "ï¿½ï¿½",
        "smoking"
      ],
      [
        "ï¿½ï¿½",
        "bomb"
      ],
      [
        "ï¿½ï¿½",
        "gun"
      ],
      [
        "ï¿½ï¿½",
        "hocho"
      ],
      [
        "ï¿½ï¿½",
        "pill"
      ],
      [
        "ï¿½ï¿½",
        "syringe"
      ],
      [
        "ï¿½ï¿½",
        "moneybag"
      ],
      [
        "ï¿½ï¿½",
        "yen"
      ],
      [
        "ï¿½ï¿½",
        "dollar"
      ],
      [
        "ï¿½ï¿½",
        "credit_card"
      ],
      [
        "ï¿½ï¿½",
        "money_with_wings"
      ],
      [
        "ï¿½ï¿½",
        "calling"
      ],
      [
        "ï¿½ï¿½",
        "e-mail"
      ],
      [
        "ï¿½ï¿½",
        "inbox_tray"
      ],
      [
        "ï¿½ï¿½",
        "outbox_tray"
      ],
      [
        "â",
        "email"
      ],
      [
        "ï¿½ï¿½",
        "envelope_with_arrow"
      ],
      [
        "ï¿½ï¿½",
        "incoming_envelope"
      ],
      [
        "ï¿½ï¿½",
        "mailbox"
      ],
      [
        "ï¿½ï¿½",
        "mailbox_closed"
      ],
      [
        "ï¿½ï¿½",
        "postbox"
      ],
      [
        "ï¿½ï¿½",
        "package"
      ],
      [
        "ï¿½ï¿½",
        "memo"
      ],
      [
        "ï¿½ï¿½",
        "page_facing_up"
      ],
      [
        "ï¿½ï¿½",
        "page_with_curl"
      ],
      [
        "ï¿½ï¿½",
        "bookmark_tabs"
      ],
      [
        "ï¿½ï¿½",
        "bar_chart"
      ],
      [
        "ï¿½ï¿½",
        "chart_with_upwards_trend"
      ],
      [
        "ï¿½ï¿½",
        "chart_with_downwards_trend"
      ],
      [
        "ï¿½ï¿½",
        "scroll"
      ],
      [
        "ï¿½ï¿½",
        "clipboard"
      ],
      [
        "ï¿½ï¿½",
        "date"
      ],
      [
        "ï¿½ï¿½",
        "calendar"
      ],
      [
        "ï¿½ï¿½",
        "card_index"
      ],
      [
        "ï¿½ï¿½",
        "file_folder"
      ],
      [
        "ï¿½ï¿½",
        "open_file_folder"
      ],
      [
        "â",
        "scissors"
      ],
      [
        "ï¿½ï¿½",
        "pushpin"
      ],
      [
        "ï¿½ï¿½",
        "paperclip"
      ],
      [
        "â",
        "black_nib"
      ],
      [
        "â",
        "pencil2"
      ],
      [
        "ï¿½ï¿½",
        "straight_ruler"
      ],
      [
        "ï¿½ï¿½",
        "triangular_ruler"
      ],
      [
        "ï¿½ï¿½",
        "closed_book"
      ],
      [
        "ï¿½ï¿½",
        "green_book"
      ],
      [
        "ï¿½ï¿½",
        "blue_book"
      ],
      [
        "ï¿½ï¿½",
        "orange_book"
      ],
      [
        "ï¿½ï¿½",
        "notebook"
      ],
      [
        "ï¿½ï¿½",
        "notebook_with_decorative_cover"
      ],
      [
        "ï¿½ï¿½",
        "ledger"
      ],
      [
        "ï¿½ï¿½",
        "books"
      ],
      [
        "ï¿½ï¿½",
        "book"
      ],
      [
        "ï¿½ï¿½",
        "bookmark"
      ],
      [
        "ï¿½ï¿½",
        "name_badge"
      ],
      [
        "ï¿½ï¿½",
        "newspaper"
      ],
      [
        "ï¿½ï¿½",
        "art"
      ],
      [
        "ï¿½ï¿½",
        "clapper"
      ],
      [
        "ï¿½ï¿½",
        "microphone"
      ],
      [
        "ï¿½ï¿½",
        "headphones"
      ],
      [
        "ï¿½ï¿½",
        "musical_score"
      ],
      [
        "ï¿½ï¿½",
        "musical_note"
      ],
      [
        "ï¿½ï¿½",
        "notes"
      ],
      [
        "ï¿½ï¿½",
        "musical_keyboard"
      ],
      [
        "ï¿½ï¿½",
        "violin"
      ],
      [
        "ï¿½ï¿½",
        "trumpet"
      ],
      [
        "ï¿½ï¿½",
        "saxophone"
      ],
      [
        "ï¿½ï¿½",
        "guitar"
      ],
      [
        "ï¿½ï¿½",
        "space_invader"
      ],
      [
        "ï¿½ï¿½",
        "video_game"
      ],
      [
        "ï¿½ï¿½",
        "black_joker"
      ],
      [
        "ï¿½ï¿½",
        "flower_playing_cards"
      ],
      [
        "ï¿½ï¿½",
        "mahjong"
      ],
      [
        "ï¿½ï¿½",
        "game_die"
      ],
      [
        "ï¿½ï¿½",
        "dart"
      ],
      [
        "ï¿½ï¿½",
        "football"
      ],
      [
        "ï¿½ï¿½",
        "basketball"
      ],
      [
        "â½",
        "soccer"
      ],
      [
        "â¾",
        "baseball"
      ],
      [
        "ï¿½ï¿½",
        "tennis"
      ],
      [
        "ï¿½ï¿½",
        "8ball"
      ],
      [
        "ï¿½ï¿½",
        "bowling"
      ],
      [
        "â³",
        "golf"
      ],
      [
        "ï¿½ï¿½",
        "checkered_flag"
      ],
      [
        "ï¿½ï¿½",
        "trophy"
      ],
      [
        "ï¿½ï¿½",
        "ski"
      ],
      [
        "ï¿½ï¿½",
        "snowboarder"
      ],
      [
        "ï¿½ï¿½",
        "swimmer"
      ],
      [
        "ï¿½ï¿½",
        "surfer"
      ],
      [
        "ï¿½ï¿½",
        "fishing_pole_and_fish"
      ],
      [
        "â",
        "coffee"
      ],
      [
        "ï¿½ï¿½",
        "tea"
      ],
      [
        "ï¿½ï¿½",
        "sake"
      ],
      [
        "ï¿½ï¿½",
        "beer"
      ],
      [
        "ï¿½ï¿½",
        "beers"
      ],
      [
        "ï¿½ï¿½",
        "cocktail"
      ],
      [
        "ï¿½ï¿½",
        "tropical_drink"
      ],
      [
        "ï¿½ï¿½",
        "wine_glass"
      ],
      [
        "ï¿½ï¿½",
        "fork_and_knife"
      ],
      [
        "ï¿½ï¿½",
        "pizza"
      ],
      [
        "ï¿½ï¿½",
        "hamburger"
      ],
      [
        "ï¿½ï¿½",
        "fries"
      ],
      [
        "ï¿½ï¿½",
        "poultry_leg"
      ],
      [
        "ï¿½ï¿½",
        "meat_on_bone"
      ],
      [
        "ï¿½ï¿½",
        "spaghetti"
      ],
      [
        "ï¿½ï¿½",
        "curry"
      ],
      [
        "ï¿½ï¿½",
        "fried_shrimp"
      ],
      [
        "ï¿½ï¿½",
        "bento"
      ],
      [
        "ï¿½ï¿½",
        "sushi"
      ],
      [
        "ï¿½ï¿½",
        "fish_cake"
      ],
      [
        "ï¿½ï¿½",
        "rice_ball"
      ],
      [
        "ï¿½ï¿½",
        "rice_cracker"
      ],
      [
        "ï¿½ï¿½",
        "rice"
      ],
      [
        "ï¿½ï¿½",
        "ramen"
      ],
      [
        "ï¿½ï¿½",
        "stew"
      ],
      [
        "ï¿½ï¿½",
        "oden"
      ],
      [
        "ï¿½ï¿½",
        "dango"
      ],
      [
        "ï¿½ï¿½",
        "egg"
      ],
      [
        "ï¿½ï¿½",
        "bread"
      ],
      [
        "ï¿½ï¿½",
        "doughnut"
      ],
      [
        "ï¿½ï¿½",
        "custard"
      ],
      [
        "ï¿½ï¿½",
        "icecream"
      ],
      [
        "ï¿½ï¿½",
        "ice_cream"
      ],
      [
        "ï¿½ï¿½",
        "shaved_ice"
      ],
      [
        "ï¿½ï¿½",
        "birthday"
      ],
      [
        "ï¿½ï¿½",
        "cake"
      ],
      [
        "ï¿½ï¿½",
        "cookie"
      ],
      [
        "ï¿½ï¿½",
        "chocolate_bar"
      ],
      [
        "ï¿½ï¿½",
        "candy"
      ],
      [
        "ï¿½ï¿½",
        "lollipop"
      ],
      [
        "ï¿½ï¿½",
        "honey_pot"
      ],
      [
        "ï¿½ï¿½",
        "apple"
      ],
      [
        "ï¿½ï¿½",
        "green_apple"
      ],
      [
        "ï¿½ï¿½",
        "tangerine"
      ],
      [
        "ï¿½ï¿½",
        "cherries"
      ],
      [
        "ï¿½ï¿½",
        "grapes"
      ],
      [
        "ï¿½ï¿½",
        "watermelon"
      ],
      [
        "ï¿½ï¿½",
        "strawberry"
      ],
      [
        "ï¿½ï¿½",
        "peach"
      ],
      [
        "ï¿½ï¿½",
        "melon"
      ],
      [
        "ï¿½ï¿½",
        "banana"
      ],
      [
        "ï¿½ï¿½",
        "pineapple"
      ],
      [
        "ï¿½ï¿½",
        "sweet_potato"
      ],
      [
        "ï¿½ï¿½",
        "eggplant"
      ],
      [
        "ï¿½ï¿½",
        "tomato"
      ],
      [
        "ï¿½ï¿½",
        "corn"
      ]
    ],
    "name": "Objects",
    "icon": ["ï¿½ï¿½", "bell"]
  },
  {
    "emojis": [
      [
        "ï¿½ï¿½",
        "house"
      ],
      [
        "ï¿½ï¿½",
        "house_with_garden"
      ],
      [
        "ï¿½ï¿½",
        "school"
      ],
      [
        "ï¿½ï¿½",
        "office"
      ],
      [
        "ï¿½ï¿½",
        "post_office"
      ],
      [
        "ï¿½ï¿½",
        "hospital"
      ],
      [
        "ï¿½ï¿½",
        "bank"
      ],
      [
        "ï¿½ï¿½",
        "convenience_store"
      ],
      [
        "ï¿½ï¿½",
        "love_hotel"
      ],
      [
        "ï¿½ï¿½",
        "hotel"
      ],
      [
        "ï¿½ï¿½",
        "wedding"
      ],
      [
        "âª",
        "church"
      ],
      [
        "ï¿½ï¿½",
        "department_store"
      ],
      [
        "ï¿½ï¿½",
        "city_sunrise"
      ],
      [
        "ï¿½ï¿½",
        "city_sunset"
      ],
      [
        "ï¿½ï¿½",
        "japanese_castle"
      ],
      [
        "ï¿½ï¿½",
        "european_castle"
      ],
      [
        "âº",
        "tent"
      ],
      [
        "ï¿½ï¿½",
        "factory"
      ],
      [
        "ï¿½ï¿½",
        "tokyo_tower"
      ],
      [
        "ï¿½ï¿½",
        "japan"
      ],
      [
        "ï¿½ï¿½",
        "mount_fuji"
      ],
      [
        "ï¿½ï¿½",
        "sunrise_over_mountains"
      ],
      [
        "ï¿½ï¿½",
        "sunrise"
      ],
      [
        "ï¿½ï¿½",
        "night_with_stars"
      ],
      [
        "ï¿½ï¿½",
        "statue_of_liberty"
      ],
      [
        "ï¿½ï¿½",
        "bridge_at_night"
      ],
      [
        "ï¿½ï¿½",
        "carousel_horse"
      ],
      [
        "ï¿½ï¿½",
        "ferris_wheel"
      ],
      [
        "â²",
        "fountain"
      ],
      [
        "ï¿½ï¿½",
        "roller_coaster"
      ],
      [
        "ï¿½ï¿½",
        "ship"
      ],
      [
        "âµ",
        "boat"
      ],
      [
        "ï¿½ï¿½",
        "speedboat"
      ],
      [
        "â",
        "anchor"
      ],
      [
        "ï¿½ï¿½",
        "rocket"
      ],
      [
        "â",
        "airplane"
      ],
      [
        "ï¿½ï¿½",
        "seat"
      ],
      [
        "ï¿½ï¿½",
        "station"
      ],
      [
        "ï¿½ï¿½",
        "bullettrain_side"
      ],
      [
        "ï¿½ï¿½",
        "bullettrain_front"
      ],
      [
        "ï¿½ï¿½",
        "metro"
      ],
      [
        "ï¿½ï¿½",
        "railway_car"
      ],
      [
        "ï¿½ï¿½",
        "bus"
      ],
      [
        "ï¿½ï¿½",
        "blue_car"
      ],
      [
        "ï¿½ï¿½",
        "car"
      ],
      [
        "ï¿½ï¿½",
        "taxi"
      ],
      [
        "ï¿½ï¿½",
        "truck"
      ],
      [
        "ï¿½ï¿½",
        "rotating_light"
      ],
      [
        "ï¿½ï¿½",
        "police_car"
      ],
      [
        "ï¿½ï¿½",
        "fire_engine"
      ],
      [
        "ï¿½ï¿½",
        "ambulance"
      ],
      [
        "ï¿½ï¿½",
        "bike"
      ],
      [
        "ï¿½ï¿½",
        "barber"
      ],
      [
        "ï¿½ï¿½",
        "busstop"
      ],
      [
        "ï¿½ï¿½",
        "ticket"
      ],
      [
        "ï¿½ï¿½",
        "traffic_light"
      ],
      [
        "â ",
        "warning"
      ],
      [
        "ï¿½ï¿½",
        "construction"
      ],
      [
        "ï¿½ï¿½",
        "beginner"
      ],
      [
        "â½",
        "fuelpump"
      ],
      [
        "ï¿½ï¿½",
        "izakaya_lantern"
      ],
      [
        "ï¿½ï¿½",
        "slot_machine"
      ],
      [
        "â¨",
        "hotsprings"
      ],
      [
        "ï¿½ï¿½",
        "moyai"
      ],
      [
        "ï¿½ï¿½",
        "circus_tent"
      ],
      [
        "ï¿½ï¿½",
        "performing_arts"
      ],
      [
        "ï¿½ï¿½",
        "round_pushpin"
      ],
      [
        "ï¿½ï¿½",
        "triangular_flag_on_post"
      ]
    ],
    "name": "Places",
    "icon": ["ï¿½ï¿½", "blue_car"]
  },
  {
    "emojis": [
      [
        "ï¿½ï¿½",
        "keycap_ten"
      ],
      [
        "ï¿½ï¿½",
        "1234"
      ],
      [
        "ï¿½ï¿½",
        "symbols"
      ],
      [
        "â¬",
        "arrow_up"
      ],
      [
        "â¬",
        "arrow_down"
      ],
      [
        "â¬",
        "arrow_left"
      ],
      [
        "â¡",
        "arrow_right"
      ],
      [
        "ï¿½ï¿½",
        "capital_abcd"
      ],
      [
        "ï¿½ï¿½",
        "abcd"
      ],
      [
        "ï¿½ï¿½",
        "abc"
      ],
      [
        "â",
        "arrow_upper_right"
      ],
      [
        "â",
        "arrow_upper_left"
      ],
      [
        "â",
        "arrow_lower_right"
      ],
      [
        "â",
        "arrow_lower_left"
      ],
      [
        "â",
        "left_right_arrow"
      ],
      [
        "â",
        "arrow_up_down"
      ],
      [
        "â",
        "arrow_backward"
      ],
      [
        "â¶",
        "arrow_forward"
      ],
      [
        "ï¿½ï¿½",
        "arrow_up_small"
      ],
      [
        "ï¿½ï¿½",
        "arrow_down_small"
      ],
      [
        "â©",
        "leftwards_arrow_with_hook"
      ],
      [
        "âª",
        "arrow_right_hook"
      ],
      [
        "â¹",
        "information_source"
      ],
      [
        "âª",
        "rewind"
      ],
      [
        "â©",
        "fast_forward"
      ],
      [
        "â«",
        "arrow_double_up"
      ],
      [
        "â¬",
        "arrow_double_down"
      ],
      [
        "â¤µ",
        "arrow_heading_down"
      ],
      [
        "â¤´",
        "arrow_heading_up"
      ],
      [
        "ï¿½ï¿½",
        "ok"
      ],
      [
        "ï¿½ï¿½",
        "new"
      ],
      [
        "ï¿½ï¿½",
        "up"
      ],
      [
        "ï¿½ï¿½",
        "cool"
      ],
      [
        "ï¿½ï¿½",
        "free"
      ],
      [
        "ï¿½ï¿½",
        "ng"
      ],
      [
        "ï¿½ï¿½",
        "signal_strength"
      ],
      [
        "ï¿½ï¿½",
        "cinema"
      ],
      [
        "ï¿½ï¿½",
        "koko"
      ],
      [
        "ï¿½ï¿½",
        "u6307"
      ],
      [
        "ï¿½ï¿½",
        "u7a7a"
      ],
      [
        "ï¿½ï¿½",
        "u6e80"
      ],
      [
        "ï¿½ï¿½",
        "u5408"
      ],
      [
        "ï¿½ï¿½",
        "u7981"
      ],
      [
        "ï¿½ï¿½",
        "ideograph_advantage"
      ],
      [
        "ï¿½ï¿½",
        "u5272"
      ],
      [
        "ï¿½ï¿½",
        "u55b6"
      ],
      [
        "ï¿½ï¿½",
        "u6709"
      ],
      [
        "ï¿½ï¿½",
        "u7121"
      ],
      [
        "ï¿½ï¿½",
        "restroom"
      ],
      [
        "ï¿½ï¿½",
        "mens"
      ],
      [
        "ï¿½ï¿½",
        "womens"
      ],
      [
        "ï¿½ï¿½",
        "baby_symbol"
      ],
      [
        "ï¿½ï¿½",
        "wc"
      ],
      [
        "ï¿½ï¿½",
        "parking"
      ],
      [
        "â¿",
        "wheelchair"
      ],
      [
        "ï¿½ï¿½",
        "no_smoking"
      ],
      [
        "ï¿½ï¿½",
        "u6708"
      ],
      [
        "ï¿½ï¿½",
        "u7533"
      ],
      [
        "ï¿½ï¿½",
        "sa"
      ],
      [
        "â",
        "m"
      ],
      [
        "ï¿½ï¿½",
        "accept"
      ],
      [
        "ã",
        "secret"
      ],
      [
        "ã",
        "congratulations"
      ],
      [
        "ï¿½ï¿½",
        "cl"
      ],
      [
        "ï¿½ï¿½",
        "sos"
      ],
      [
        "ï¿½ï¿½",
        "id"
      ],
      [
        "ï¿½ï¿½",
        "no_entry_sign"
      ],
      [
        "ï¿½ï¿½",
        "underage"
      ],
      [
        "â",
        "no_entry"
      ],
      [
        "â³",
        "eight_spoked_asterisk"
      ],
      [
        "â",
        "sparkle"
      ],
      [
        "â",
        "negative_squared_cross_mark"
      ],
      [
        "â",
        "white_check_mark"
      ],
      [
        "â´",
        "eight_pointed_black_star"
      ],
      [
        "ï¿½ï¿½",
        "heart_decoration"
      ],
      [
        "ï¿½ï¿½",
        "vs"
      ],
      [
        "ï¿½ï¿½",
        "vibration_mode"
      ],
      [
        "ï¿½ï¿½",
        "mobile_phone_off"
      ],
      [
        "ï¿½ï¿½",
        "a"
      ],
      [
        "ï¿½ï¿½",
        "b"
      ],
      [
        "ï¿½ï¿½",
        "ab"
      ],
      [
        "ï¿½ï¿½",
        "o2"
      ],
      [
        "ï¿½ï¿½",
        "diamond_shape_with_a_dot_inside"
      ],
      [
        "â»",
        "recycle"
      ],
      [
        "â",
        "aries"
      ],
      [
        "â",
        "taurus"
      ],
      [
        "â",
        "gemini"
      ],
      [
        "â",
        "cancer"
      ],
      [
        "â",
        "leo"
      ],
      [
        "â",
        "virgo"
      ],
      [
        "â",
        "libra"
      ],
      [
        "â",
        "scorpius"
      ],
      [
        "â",
        "sagittarius"
      ],
      [
        "â",
        "capricorn"
      ],
      [
        "â",
        "aquarius"
      ],
      [
        "â",
        "pisces"
      ],
      [
        "â",
        "ophiuchus"
      ],
      [
        "ï¿½ï¿½",
        "six_pointed_star"
      ],
      [
        "ï¿½ï¿½",
        "atm"
      ],
      [
        "ï¿½ï¿½",
        "chart"
      ],
      [
        "ï¿½ï¿½",
        "heavy_dollar_sign"
      ],
      [
        "ï¿½ï¿½",
        "currency_exchange"
      ],
      [
        "â",
        "x"
      ],
      [
        "â¼",
        "bangbang"
      ],
      [
        "â",
        "interrobang"
      ],
      [
        "â",
        "exclamation"
      ],
      [
        "â",
        "question"
      ],
      [
        "â",
        "grey_exclamation"
      ],
      [
        "â",
        "grey_question"
      ],
      [
        "â­",
        "o"
      ],
      [
        "ï¿½ï¿½",
        "top"
      ],
      [
        "ï¿½ï¿½",
        "end"
      ],
      [
        "ï¿½ï¿½",
        "back"
      ],
      [
        "ï¿½ï¿½",
        "on"
      ],
      [
        "ï¿½ï¿½",
        "soon"
      ],
      [
        "ï¿½ï¿½",
        "arrows_clockwise"
      ],
      [
        "ï¿½ï¿½",
        "clock12"
      ],
      [
        "ï¿½ï¿½",
        "clock1"
      ],
      [
        "ï¿½ï¿½",
        "clock2"
      ],
      [
        "ï¿½ï¿½",
        "clock3"
      ],
      [
        "ï¿½ï¿½",
        "clock4"
      ],
      [
        "ï¿½ï¿½",
        "clock5"
      ],
      [
        "ï¿½ï¿½",
        "clock6"
      ],
      [
        "ï¿½ï¿½",
        "clock7"
      ],
      [
        "ï¿½ï¿½",
        "clock8"
      ],
      [
        "ï¿½ï¿½",
        "clock9"
      ],
      [
        "ï¿½ï¿½",
        "clock10"
      ],
      [
        "ï¿½ï¿½",
        "clock11"
      ],
      [
        "â",
        "heavy_multiplication_x"
      ],
      [
        "â",
        "heavy_plus_sign"
      ],
      [
        "â",
        "heavy_minus_sign"
      ],
      [
        "â",
        "heavy_division_sign"
      ],
      [
        "â ",
        "spades"
      ],
      [
        "â¥",
        "hearts"
      ],
      [
        "â£",
        "clubs"
      ],
      [
        "â¦",
        "diamonds"
      ],
      [
        "ï¿½ï¿½",
        "white_flower"
      ],
      [
        "ï¿½ï¿½",
        "100"
      ],
      [
        "â",
        "heavy_check_mark"
      ],
      [
        "â",
        "ballot_box_with_check"
      ],
      [
        "ï¿½ï¿½",
        "radio_button"
      ],
      [
        "ï¿½ï¿½",
        "link"
      ],
      [
        "â°",
        "curly_loop"
      ],
      [
        "ã°",
        "wavy_dash"
      ],
      [
        "ã½",
        "part_alternation_mark"
      ],
      [
        "ï¿½ï¿½",
        "trident"
      ],
      [
        "â¼",
        "black_medium_square"
      ],
      [
        "â»",
        "white_medium_square"
      ],
      [
        "â¾",
        "black_medium_small_square"
      ],
      [
        "â½",
        "white_medium_small_square"
      ],
      [
        "âª",
        "black_small_square"
      ],
      [
        "â«",
        "white_small_square"
      ],
      [
        "ï¿½ï¿½",
        "small_red_triangle"
      ],
      [
        "ï¿½ï¿½",
        "black_square_button"
      ],
      [
        "ï¿½ï¿½",
        "white_square_button"
      ],
      [
        "â«",
        "black_circle"
      ],
      [
        "âª",
        "white_circle"
      ],
      [
        "ï¿½ï¿½",
        "red_circle"
      ],
      [
        "ï¿½ï¿½",
        "large_blue_circle"
      ],
      [
        "ï¿½ï¿½",
        "small_red_triangle_down"
      ],
      [
        "â¬",
        "white_large_square"
      ],
      [
        "â¬",
        "black_large_square"
      ],
      [
        "ï¿½ï¿½",
        "large_orange_diamond"
      ],
      [
        "ï¿½ï¿½",
        "large_blue_diamond"
      ],
      [
        "ï¿½ï¿½",
        "small_orange_diamond"
      ],
      [
        "ï¿½ï¿½",
        "small_blue_diamond"
      ]
    ],
    "name": "Symbols",
    "icon": ["ï¿½ï¿½", "capital_abcd"]
  }
];
